var userPrintPreferences = {
    showPlots: true,
    showNumericalResults: false
}

function initializePrintPreferencesDialog() {
    document.getElementById("print-preferences-dialog-save-button").addEventListener("click", function() {
        savePrintPreferences();
        printWithPreferences();
    });

    updatePrintPreferencesDialogFields();
}

function savePrintPreferences() {
    userPrintPreferences.showPlots = document.getElementById("show-plots-print-preference-check").checked;
    userPrintPreferences.showNumericalResults = document.getElementById("show-numerical-results-print-preference-check").checked;
}

function printBeamDesign() {
    window.print()
    document.getElementById('modal-print-preferences-dialog').removeEventListener('hidden.bs.modal', printBeamDesign)
}

function printWithPreferences() {
    if(userPrintPreferences.showPlots) {
        document.getElementById("plots-div").classList.remove("hidden-print");
    } else {
        document.getElementById("plots-div").classList.add("hidden-print");
    }

    if(userPrintPreferences.showNumericalResults) {
        document.getElementById("numerical-results-div").classList.remove("hidden-print");
    } else {
        document.getElementById("numerical-results-div").classList.add("hidden-print");
    }

    bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-print-preferences-dialog')).hide()

    // add a temporary event listener to ensure that print preview does not include the modal backdrop
    document.getElementById('modal-print-preferences-dialog').addEventListener('hidden.bs.modal', printBeamDesign)    
}

function updatePrintPreferencesDialogFields() {
    document.getElementById("show-plots-print-preference-check").checked = userPrintPreferences.showPlots;
    document.getElementById("show-numerical-results-print-preference-check").checked = userPrintPreferences.showNumericalResults;
}